import React from "react";
import { handelExternalLinkClick } from "../../../utilities/WespoUtil";
import classes from "./TextDecoration.module.scss";

export type LineElement = {
  text?: string | string[];
  image?: string;
  url?: string;
  style?: string[];
  isInline?: boolean;
};

/**
 * テキスト装飾プロパティ
 */
type TextDecorationProps = {
  /** 文章要素 */
  sentences?: LineElement[];
};

/**
 * テキスト装飾コンポーネント
 * @param props テキスト装飾プロパティ
 */
const TextDecoration: React.FC<TextDecorationProps> = (props) => {
  if (!props.sentences) {
    return null;
  }

  const getElementContent = (element: LineElement) => {
    if (element.image) {
      return <img className="img-fluid d-inline" src={element.image} alt="" />;
    } else {
      return typeof element.text === "string" ? (
        <span className={element.style?.join(" ")}>{element.text}</span>
      ) : element.text?.every((value) => !value) ? null : (
        element.text?.map((e, index) => {
          return (
            <React.Fragment key={`element-content-${index}`}>
              {index > 0 ? <br></br> : null}
              <span className={element.style?.join(" ")}>{e}</span>
            </React.Fragment>
          );
        })
      );
    }
  };

  return (
    <React.Fragment>
      {props.sentences.map((lineElement: LineElement | string, index) => {
        const element: LineElement =
          typeof lineElement === "string"
            ? {
                text: lineElement,
              }
            : lineElement;
        return (
          <React.Fragment key={index}>
            {element.url ? (
              <a
                className={`${classes.link} ${element.style?.join(" ") || ""}`}
                href={element.url}
                onClick={(event) =>
                  element.url ? handelExternalLinkClick(event, element.url) : {}
                }
              >
                {getElementContent(element) || element.url}
              </a>
            ) : (
              getElementContent(element)
            )}
            {element.isInline ? "" : <br />}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export default TextDecoration;
